import { ICreditCardInfo } from "./ICreditCardInfo";

export class CreditCardInfo implements ICreditCardInfo {
    cardNumber = "";
    cardholderName = "";
    expirationMmYy = "";
    securityCode = "";
}
